<div mat-dialog-content class="call-as-body">
  <mat-card-title class="text-no-wrap outbound-title">
    {{ title$ | async | translate }}
  </mat-card-title>
  <div class="outbound-form-wrapper">
    <nimbus-form-wrapper [formGroup]="form">
      <nimbus-form-row>
        <nimbus-form-control>
          <app-nimbus-input-assistant-autocomplete
            [label]="TranslationKeys.CallAsNameNumber | translate"
            [isPhoneNumberDisabled]="isPhoneNumberDisabled"
            #userAutocomplete
            id="contactId"
            formControlName="contactId"
            [required]="true"
            (selectionChange)="onTargetAutocompleteSelectionChange($event)"
          >
          </app-nimbus-input-assistant-autocomplete>
        </nimbus-form-control>
      </nimbus-form-row>
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-call-as-dial
            class="dial"
            [isDisabled]="isPhoneNumberDisabled"
            (dialButtonClick)="onDialButtonClick($event)"
            (dialButtonLongPress)="onDialButtonLongPress($event)"
          >
          </nimbus-call-as-dial>
        </nimbus-form-control>
      </nimbus-form-row>
      @if (!(transferService.callTransfer$ | async)) {
        <nimbus-form-row class="service-input">
          <nimbus-form-control>
            <nimbus-input-autocomplete
              defaultSearch
              id="teamId"
              formControlName="teamId"
              panelClass="assistant-outbound-service"
              [label]="TranslationKeys.CallAsOutboundService | translate"
              [required]="true"
              [options]="outboundService.services$ | async"
            >
            </nimbus-input-autocomplete>
          </nimbus-form-control>
        </nimbus-form-row>
      }
    </nimbus-form-wrapper>
  </div>
</div>

<div class="outbound-footer">
  <div id="cancelButton" class="outbound-footer-action" (click)="onCancel()" cdkFocusInitial>
    <div class="action-content">
      <span class="action-text">{{ TranslationKeys.GeneralCancel | translate }}</span>
    </div>
  </div>
  <div id="callAsButton" class="outbound-footer-action" [class.disabled]="!form.valid || !isCallButtonEnabled" (click)="onCall()">
    <div class="action-content">
      <i [nimbusIcon]="callIcon"></i>
      <span class="action-text">{{ callText | translate }}</span>
    </div>
  </div>
</div>
